import React from "react";
import { Form, Row, Col } from "react-bootstrap";

const ClientSection = ({ formData, formErrors, onInputChange }) => {
  return (
    <div className="appointment-section">
      <h6 className="section-title" style={{fontWeight: "bold"}}>Client</h6>
      <div className="section-fields">
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Name <span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="text"
                value={formData.clientName}
                onChange={(e) => onInputChange("clientName", e.target.value)}
                isInvalid={!!formErrors.clientName}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.clientName}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Phone</Form.Label>
              <Form.Control
                type="tel"
                value={formData.clientPhone}
                onChange={(e) => onInputChange("clientPhone", e.target.value)}
                isInvalid={!!formErrors.clientPhone}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.clientPhone}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
        
        <Row className="mb-3">
          <Col md={6}>
            <Form.Group>
              <Form.Label>Email <span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="email"
                value={formData.clientEmail}
                onChange={(e) => onInputChange("clientEmail", e.target.value)}
                isInvalid={!!formErrors.clientEmail}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.clientEmail}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label>Note</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={formData.clientNote}
                onChange={(e) => onInputChange("clientNote", e.target.value)}
                isInvalid={!!formErrors.clientNote}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.clientNote}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ClientSection;